/**
 * Card hover transform — matches Tailwind `md` / desktop card grid
 * (no sticky hover styles on the mobile carousel).
 */
export const PRESSURE_CARD_HOVER_MEDIA = '(width >= 48rem)' as const;

/**
 * Figma Card hover (`1224:48939`): panel rotation −3.1° (clockwise) + centre
 * lift ≈ −20px. CSS/Motion positive rotate is clockwise — no blur / drop shadow.
 */
export const PRESSURE_CARD_HOVER_ROTATE_DEG = 3;

/** Upward shift on hover (px); Motion `y`. */
export const PRESSURE_CARD_HOVER_Y_PX = -20;

/** Sub-pixel tolerance when deciding whether reveal copy has reached its end. */
export const PRESSURE_CARD_SCROLL_END_THRESHOLD_PX = 2;
